import React, { useEffect, useState } from 'react';
import Navigation from './Navigation';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const QuestionsTextSingle = ({
  data,
  dataItems,
  name,
  nextStep,
  handleData,
  userContact,
  surfaceValid,
  step,
  lastStep,
  onForm,
  phoneValid,
  emailValid,
  codepostalValid,
}) => {
  const [hasError, setHasError] = useState(false);
  const focusFirstInput = () => {
    const inputs = document.querySelectorAll('input:not(input[type="radio"])');
    if (inputs.length > 0 && !inputs[0].value) {
      inputs[0].focus();
    }
  };

  useEffect(() => {
    focusFirstInput(); // on mount
  }, []);

  useEffect(() => {
    focusFirstInput(); // on update
  });

  useEffect(() => {
    setHasError(surfaceValid);
  }, [surfaceValid]);

  const renderValidationError = (item) => {
    // if (!onForm) return null;

    const validationMap = {
      phone: !phoneValid,
      email: !emailValid,
      codepostal: !codepostalValid,
      surface: surfaceValid,
    };

    const showError = validationMap[item.validation];

    if (!showError) return null;

    const messages = {
      phone: 'Veuillez entrer un numéro valide',
      email: 'Veuillez entrer un email valide',
      codepostal: 'Veuillez entrer un code postal valide',
      surface: item.error,
    };

    return (
      <div className="w-full flex flex-row items-center justify-center lg:inline-block">
        <div className="validate-error">{messages[item.validation]}</div>
      </div>
    );
  };

  return (
    <div className="fadeIn flex flex-col justify-between">
      <div className="w-100 d-flex jcc">
        <div style={{ minWidth: '360px' }} className="d-flex column">
          <div className="mb-50">
            {dataItems[name].items.map((item) => (
              <div className="flex flex-col space-y-2" key={item.name}>
                <div className="input-container flex-input items-center">
                  <label
                    className={clsx(
                      'mv-20 text-main is-bold is-hidden-mobile',
                      {
                        'flex-1': dataItems[name].labelNoWrap,
                      },
                    )}
                    style={{ width: '118px', fontSize: '18px' }}
                  >
                    {item.label}
                  </label>

                  <div className="mv-10">
                    {
                      <InputQuestionsText
                        item={item}
                        userContact={userContact}
                        data={data}
                        nextStep={nextStep}
                        handleData={handleData}
                      />
                    }
                  </div>
                </div>

                {renderValidationError(item)}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Navigation
        data={hasError ? undefined : data}
        step={step}
        nextStep={nextStep}
        lastStep={lastStep}
      />
    </div>
  );
};

const InputQuestionsText = (props) => {
  const { item, userContact, data, nextStep, handleData } = props;

  const commonProps = {
    type: item.type || 'text',
    placeholder: item.placeholder,
    name: item.name,
    onKeyPress: (e) => e.key === 'Enter' && data && nextStep(),
    style: { minWidth: 'auto' },
    value: userContact[item.name],
  };

  if (item.type === 'number') {
    return (
      <input
        {...commonProps}
        onChange={handleData}
        min={item.min}
        step={item.step}
        autoFocus
      />
    );
  }

  return (
    <input
      {...commonProps}
      onChange={handleData}
      maxLength={item.maxLength}
      minLength={item.minLength}
    />
  );
};

InputQuestionsText.propTypes = {
  item: PropTypes.object,
  userContact: PropTypes.any,
  data: PropTypes.any,
  nextStep: PropTypes.func,
  handleData: PropTypes.func,
};

QuestionsTextSingle.propTypes = {
  data: PropTypes.any, // ou PropTypes.object si plus précis
  dataItems: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  nextStep: PropTypes.func.isRequired,
  handleData: PropTypes.func.isRequired,
  userContact: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  lastStep: PropTypes.func.isRequired,
  onForm: PropTypes.bool,
  phoneValid: PropTypes.bool,
  emailValid: PropTypes.bool,
  surfaceValid: PropTypes.bool,
  codepostalValid: PropTypes.bool,
};

export default QuestionsTextSingle;